module.exports = __webpack_public_path__ + "img/Tier 2.cec7f97d.png";